var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bindsuccess"},[_c('p',{staticClass:"check_title"},[_vm._v(_vm._s(_vm.$t('boundEmail'))+":")]),_c('p',[_vm._v(_vm._s(_vm.email))]),_c('van-button',{staticClass:"back_btn",attrs:{"type":"danger","block":"","round":""},on:{"click":_vm.backPage}},[_vm._v(" "+_vm._s(_vm.$t('return'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }